import { graphql } from '../../gql';

export const GET_SAVED_SETS = graphql(`
  query GetSavedSets {
    presets {
      id
      name
      view
      default
      shared
      filters
    }
  }
`);

export const CREATE_SAVED_SET = graphql(`
  mutation createPreset($name: String!, $view: View!, $filters: String!) {
    createPreset(
      input: {
        name: $name
        view: $view
        default: false
        shared: false
        filters: $filters
      }
    ) {
      id
      name
      view
      default
      shared
      filters
    }
  }
`);

export const UPDATE_SAVED_SET = graphql(`
  mutation updatePreset(
    $id: String!
    $name: String
    $view: View
    $filters: String
  ) {
    updatePreset(
      input: { id: $id, name: $name, view: $view, filters: $filters }
    ) {
      id
      name
      view
      default
      shared
      filters
    }
  }
`);

export const DELETE_SAVED_SET = graphql(`
  mutation deletePreset($id: String!) {
    deletePreset(id: $id)
  }
`);
